export default "__VITE_ASSET__DgNlRXxo__"